export default "/images/message.svg?eb2adac27f520e61f573591f4b76ae72";